

































export default {
    name: "DisponibilitesCalendarLabels",
    props: {
        isFrequenceView: {
            type: Boolean,
            default: false,
        },
        frequencesName: {
            type: String,
            default: "",
        },
    },
};
